import React from 'react';
import { Car, BatteryCharging, Truck, Bus, Bike, Ship, Tractor } from 'lucide-react';

const FAHRZEUGARTEN = [
  { name: 'PKW', icon: Car },
  { name: 'Elektrofahrzeuge', icon: BatteryCharging },
  { name: 'LKW', icon: Truck },
  { name: 'Busse', icon: Bus },
  { name: 'Motorräder', icon: Bike },
  { name: 'Fahrräder', icon: Bike },
  { name: 'Boote', icon: Ship }
];

export const FahrzeugArtenSection = () => {
  return (
    <section className="py-28 lg:py-36 bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-green/8 text-brand-green-dark rounded-full text-sm font-semibold mb-6 border border-brand-green/15">
            Fahrzeugarten
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 tracking-tight">
            Gutachten für alle Fahrzeugarten
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-6">
          {FAHRZEUGARTEN.map((fahrzeug, index) => {
            const Icon = fahrzeug.icon;
            return (
              <div key={index} className="flex flex-col items-center text-center p-6 bg-gradient-to-br from-gray-50 to-white border border-gray-100 rounded-2xl hover:border-brand-green/30 hover:shadow-xl transition-all duration-300">
                <div className="w-14 h-14 bg-brand-green/10 rounded-xl flex items-center justify-center mb-4 border border-brand-green/15">
                  <Icon className="w-7 h-7 text-brand-green" />
                </div>
                <span className="text-[15px] font-bold text-gray-900">{fahrzeug.name}</span>
              </div>
            );
          })}
        </div>

        <div className="mt-10 text-center">
          <p className="text-sm text-gray-500 italic">
            Die Begutachtung ist abhängig vom Schadenbild und Einzelfall. Bei Fragen sprechen Sie uns gerne an.
          </p>
        </div>
      </div>
    </section>
  );
};